import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";
import moment from "moment";
import { Loading } from "element-ui";
import store from "../store";
import router from "../router";

// timezone setting change ** require
Date.prototype.toISOString = function () {
  return moment(this).format();
};
Date.prototype.toJSON = function () {
  return moment(this).format("YYYY-MM-DD[T]HH:mm:ss");
};

//var csrfToken = $("meta[name='_csrf']").attr("content");
//var csrfHeader = $("meta[name='_csrf_header']").attr("content");
//if (csrfToken != undefined && csrfHeader != undefined && csrfToken != '' && csrfHeader != '') {
//    axios.defaults.headers.post[csrfHeader] = csrfToken;
//}

const ax = axios.create({
  headers: {
    post: {
      "Content-Type": "application/json;charset=UTF-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    get: {
      "Content-Type": "application/json;charset=UTF-8",
      "X-Requested-With": "XMLHttpRequest",
    },
  },
  withCredentials: true,
});

//ax.defaults.timeout = 2500;

let loadingInstance = null;
var visibleLoading = true;
ax.interceptors.request.use(
  (config) => {
    if (store.getters.currentUser != null && store.getters.currentUser.ssnId != null) {
      ax.defaults.headers.common["X-Auth-Token"] = store.getters.currentUser.ssnId;
      // console.log("store.getters.currentUser.ssnId", store.getters.currentUser.ssnId);
    }

    if (visibleLoading) {
      loadingInstance = Loading.service({ background: "rgb(254 255 255 / 19%)", lock: true, fullscreen: true });
      document.body.style.cursor = "wait";
    }
    return config;
  },
  (error) => {
    if (loadingInstance != null) loadingInstance.close();
    document.body.style.cursor = "default";
    return Promise.reject(error);
  },
);

ax.interceptors.response.use(
  (response) => {
    if (loadingInstance != null) loadingInstance.close();
    document.body.style.cursor = "default";

    if (response.headers["isauthenticated"] != null && response.headers["isauthenticated"] == "false" && store.getters.currentUser != null) {
      // console.log('store.commit("setLogout");');
      //store.dispatch("setLogout");
      if (router.history?.current.meta.requiresAuth != null) {
        //alert("router.history?.current.meta.requiresAuth : " + router.history?.current.meta.requiresAuth);
        router.push({ path: "/login" }).catch();
      }
    }

    return response;
  },
  (error) => {
    if (loadingInstance != null) loadingInstance.close();
    document.body.style.cursor = "default";

    console.log(error.response);
    const statusCode = error.response?.status;
    if (statusCode == 401) {
      store.dispatch("setLogout");
      router.push({ path: "/login" }).catch();
      // console.log("redirect login");
    }

    return error;
  },
);

export const { hostname } =
  process.env.NODE_ENV === "production"
    ? {
        hostname: "",
      }
    : {
        hostname: "https://" + location.hostname + "",
      };

export const assetsURL = `${hostname}/assets`;
export const apiURL = `${hostname}/api`;
export const siteURL = `${hostname}`;

/**
 * 디버그 로그 (localStorage.DEBUG_MODE = 'true' 일 때만 출력)
 * 사용법: this.debug("메시지", 데이터)
 * 활성화: 브라우저 콘솔에서 localStorage.setItem('DEBUG_MODE', 'true') 입력
 * 비활성화: localStorage.removeItem('DEBUG_MODE')
 */
Vue.prototype.debug = function (...args) {
  if (localStorage.getItem("DEBUG_MODE") === "true") {
    console.log("[DEBUG]", ...args);
  }
};

// 전역에서도 사용 가능
window.debug = function (...args) {
  if (localStorage.getItem("DEBUG_MODE") === "true") {
    console.log("[DEBUG]", ...args);
  }
};

/**
 * jQuery 플러그인 초기화 함수
 * router.js와 Vue 컴포넌트 양쪽에서 사용 가능
 */
export const initJQueryPlugins = function () {
  try {
    const $ = window.$ || window.jQuery;
    if (!$) return;

    Vue.nextTick(() => {
      if (typeof $(".accordion").accordionFunc === "function") $(".accordion").accordionFunc();
      if (typeof $(".btn-arr-toggle").btnarrToggleFunc === "function") $(".btn-arr-toggle").btnarrToggleFunc();
      //if (typeof $(".form-row").inputFocusFunc === "function") $(".form-row").inputFocusFunc();
      //if (typeof $(".tabs-normal").tabsNormalFunc === "function") $(".tabs-normal").tabsNormalFunc();
    });
  } catch (e) {
    console.warn("[initJQueryPlugins]:", e.message);
  }
};

/**
 * jQuery 플러그인 초기화 (페이지 스크립트)
 * 사용법: this.initPageScripts()
 */
Vue.prototype.initPageScripts = initJQueryPlugins;

/**
 * Dim(배경 어둡게) 제어
 * 사용법: this.dim()       - 열기
 *        this.dim('close') - 닫기
 *        this.dim('toggle') - 토글
 */
Vue.prototype.dim = function (action = "open") {
  const el = document.querySelector(".dim");
  if (!el) return;
  if (action === "close") {
    el.style.display = "none";
  } else if (action === "toggle") {
    el.style.display = el.style.display === "none" ? "block" : "none";
  } else {
    el.style.display = "block";
  }
};

/**
 * SNS 로그인/가입 postMessage 한 번에 처리 (this.request 처럼 호출)
 * @param {MessageEvent} event - window/document 'message' 이벤트
 * @param {Object} options - { context: 'login' | 'signupTerm', resultMap?: Object } (login일 때 resultMap 전달)
 */
Vue.prototype.handleSnsConnect = function (event, options) {
  let data = null;
  try {
    data = event && event.data != null ? JSON.parse(event.data) : null;
  } catch (e) {
    return;
  }
  if (!data || !data.action) return;

  const ctx = options || {};
  const resultMap = ctx.resultMap != null ? ctx.resultMap : this.resultMap != null ? this.resultMap : {};

  if (data.action === "snsConnected") {
    if (ctx.context === "signupTerm") {
      this.$alert("이미 가입된 SNS 계정입니다.<br>회원가입을 중단하고 메인으로 이동합니다.", "안내", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "확인",
        callback: () => {
          this.$router.push({ path: "/main" });
        },
      });
      return;
    }

    this.$store.dispatch("setSessionRetrive", resultMap).then(() => {
      // SNS 로그인 타입 저장
      const loginType = localStorage.getItem("pendingLoginType");
      if (loginType) {
        localStorage.setItem("lastLoginType", loginType);
        localStorage.removeItem("pendingLoginType");
      }

      this.loader("close");
      const user = store.getters.currentUser;
      if (user && user.isAuthenticated) {
        const nextPath = localStorage.getItem("referer") || "/main";
        localStorage.removeItem("referer");
        const path = nextPath.indexOf("/login") > -1 ? "/main" : nextPath;
        this.$nextTick(() => {
          this.$store.dispatch("setSessionScope", { referer: null });
          this.$router.push({ path });
        });
      } else {
        this.$alert("SNS 로그인 중 오류가 발생 했습니다. 다시 시도해 주세요.");
      }
    });
    return;
  }

  if (data.action === "snsSignup") {
    if (ctx.context === "signupTerm") {
      this.$router.push({ path: "/signup/snsform" });
      return;
    }
    this.$confirm("가입된 SNS 계정이 없습니다. <br>회원 가입 후 이용해 주세요.", "안내", {
      dangerouslyUseHTMLString: true,
      confirmButtonText: "회원가입",
      cancelButtonText: "취소",
      callback: (action) => {
        if (action === "cancel") return;
        this.$router.push({ path: "/signup/term" });
      },
    });
    return;
  }

  if (data.action === "snsSignupExists") {
    this.$confirm("회원 계정은 있으나 SNS 연결이 되어 있지 않습니다. <br>로그인 후 마이페이지에서 SNS계정을 연결해 주세요.", "안내", {
      dangerouslyUseHTMLString: true,
      confirmButtonText: "로그인",
      cancelButtonText: "취소",
      callback: (action) => {
        if (action === "cancel") return;
        this.$router.push({ path: "/login" }).catch(() => {});
      },
    });
    return;
  }

  if (data.action === "snsError") {
    this.$alert("SNS 연결 중 오류가 발생 했습니다. 다시 시도해 주세요.");
  }
};
Vue.prototype.getCode = async function (groupCd) {
  return await Vue.prototype.request(`${apiURL}/code/list/${groupCd}`).then(({ data }) => {
    return data;
  });
};
Vue.prototype.request = function (url, param) {
  visibleLoading = false;
  if (store.getters.currentUser != null && store.getters.currentUser.ssnId != null) {
    ax.defaults.headers.common["X-Auth-Token"] = store.getters.currentUser.ssnId;
    // console.log("store.getters.currentUser.ssnId", store.getters.currentUser.ssnId);
  }

  var params = "";
  if (param != null && typeof param != "string") {
    Object.keys(param).map(function (k, v) {
      if (param[k] != undefined && typeof param[k] != "object" && typeof param[k] != "function") {
        params += "&" + k + "=" + encodeURIComponent(param[k]);
      } else if (param[k] != undefined && typeof param[k].getMonth == "function") {
        params += "&" + k + "=" + moment(param[k]).format("YYYY-MM-DDTHH:mm");
      }
    });
  } else {
    params = param != undefined ? param : "";
  }

  if (params != "") {
    url = url + (url.indexOf("?") > -1 ? "&" + params : "?" + params);
  }

  return ax.get(url);
};

Vue.prototype.submit = function (url, data, loading, headers) {
  if (store.getters.currentUser != null && store.getters.currentUser.ssnId != null) {
    ax.defaults.headers.common["X-Auth-Token"] = store.getters.currentUser.ssnId;
    // console.log("store.getters.currentUser.ssnId", store.getters.currentUser.ssnId);
  }

  visibleLoading = loading != null ? loading : true;

  var self = this;
  var fileCount = 0;
  var isSubmit = false;

  var form = getChildren(this);

  if (form != null && form.$children != null) {
    procUploadFile("COUNT", form);
  }

  //console.log("fileCount", fileCount);

  return commandSubmit();

  function procUploadFile(types, upload) {
    if (!upload) {
      return fileCount || 0;
    }

    const inputRef = upload.$refs?.input;
    const uploadFiles = inputRef?.uploadFiles;
    if (uploadFiles && uploadFiles.length > 0) {
      if (types === "COUNT") {
        try {
          if (uploadFiles.some((file) => file.status !== "uploaded" && file.status !== "success")) {
            fileCount++;
          }
        } catch (e) {}
      }
      if (types === "UPLOAD") {
        inputRef.submit();
      }
      if (types === "LOAD") {
        upload.$emit("input", upload.valueOrg);
      }
    }

    if (upload.$children && upload.$children.length > 0) {
      upload.$children.forEach((child) => {
        procUploadFile(types, child);
      });
    }
  }

  function getChildren(obj) {
    if (obj == null || obj.$children == null) return;
    let found = null;
    function search(cmp) {
      for (const key of Object.keys(cmp)) {
        if (cmp[key] === data) {
          found = cmp;
          return;
        }
      }
      cmp.$children.forEach(search);
    }
    search(obj);
    return found;
  }

  function commandSubmit() {
    return new Promise((resolve, reject) => {
      if (fileCount > 0) {
        self.$root.$off("fileUploadComplete");
        self.$root.$on("fileUploadComplete", function (file) {
          fileCount--;
          console.log("fileCount", fileCount);
          if (fileCount <= 0 && !isSubmit) {
            isSubmit = true;
            submitPost(url, data);
          }
        });

        for (let idx in form.$children) {
          procUploadFile("UPLOAD", form.$children[idx]);
        }
      } else {
        submitPost(url, data);
      }

      function submitPost(url, result) {
        return ax
          .post(url, result, {
            headers: headers,
          })
          .then((response) => {
            // console.log("response", response);
            if (response.status == 200 && response.data.status != "FAIL") {
              try {
                for (let idx in form.$children) {
                  procUploadFile("LOAD", form.$children[idx]);
                }
              } catch (e) {}
            }

            resolve(response);
          })
          .catch((e) => {
            Vue.prototype.$alert("오류가 발생되어 요청 작업이 처리되지 않았습니다.");
            reject(e);
          });
      }
    });
  }
};

Vue.prototype.isMobile = function () {
  if (/Macintosh/.test(navigator.userAgent) && "ontouchend" in document) {
    return true;
  }

  return /khsaeduapp|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

Vue.prototype.isApp = function () {
  return navigator.userAgent.indexOf("khsaeduapp") > -1;
};
Vue.prototype.isIOSApp = function () {
  return navigator.userAgent.indexOf("khsaeduapp") > -1 && /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

Vue.prototype.loader = function (action, element, text, customClass) {
  if (this.$root.loading == undefined && action == "close") {
    return;
  }
  if (action != null && action == "close") {
    this.$root.loading.close();
    this.$root.loading = null;
    return;
  }

  this.$root.loading = null;
  this.$root.loading = this.$root.$loading({
    target: element ? element : "body",
    lock: true,
    fullscreen: element ? false : true,
    text: text || "",
    spinner: "el-icon-loading",
    background: "rgb(254 255 255 / 13%)",
    customClass: customClass || "",
  });
  // console.log(this.$root.loading);

  if (action != "infinity") {
    setTimeout(() => {
      if (this.$root.loading != null) this.$root.loading.close();
    }, 120000);
  }
};

Vue.prototype.smload = function (element, action) {
  // console.log("===========");
  // console.log(this.$root.loading2);

  if (this.$root.loading2 == undefined && action == "close") {
    return;
  }
  if (action != null && action == "close") {
    this.$root.loading2.close();
    return;
  }

  this.$root.loading2 = this.$root.$loading({
    target: "div",
    lock: true,
    fullscreen: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgb(254 255 255 / 19%)",
  });
  // console.log(this.$root.loading);

  setTimeout(() => {
    this.$root.loading2.close();
  }, 120000);
};

Vue.prototype.responseResult = function (res, isSuccess) {
  var response = res || {};
  if (response.status == null || response.status == undefined) {
    Vue.prototype.$alert("오류가 발생되어 요청 작업이 처리되지 않았습니다.", "안내", {
      confirmButtonText: "확인",
      dangerouslyUseHTMLString: true,
      callback: (action) => {
        if (this.$root.loading != null) this.$root.loading.close();
      },
    });
  } else if (response.status != "FAIL" && !isSuccess) {
    return true;
  } else if (response.status != "FAIL") {
    this.$notify({
      title: "Success",
      type: "success",
      message: response.result,
      dangerouslyUseHTMLString: true,
      duration: 3000,
      onClose: () => {
        if (this.$root.loading != null) this.$root.loading.close();
      },
    });

    return true;
  } else {
    let messages = "";
    if (typeof response.result == "object") {
      response.result.forEach((collection) => {
        messages += collection.message;
        messages += "<br>";
      });

      Vue.prototype.$alert(messages, "안내", {
        confirmButtonText: "확인",
        dangerouslyUseHTMLString: true,
        callback: (action) => {
          if (this.$root.loading != null) this.$root.loading.close();
        },
      });
    } else {
      if (response.result.startsWith("500")) {
        messages = "오류가 발생하여 데이터를 가져오지 못했습니다.\n관리자에게 문의 하시기 바랍니다.";
      } else if (response.result.startsWith("503")) {
        messages = "서비스가 활성화 되어 있지 않습니다.\n관리자에게 문의 하시기 바랍니다.";
      } else if (response.result.startsWith("401")) {
        messages = "로그인 후 이용해 주세요.";
      } else {
        messages = response.result;
      }

      Vue.prototype.$alert(messages, "안내", {
        confirmButtonText: "확인",
        callback: (action) => {
          if (this.$root.loading != null) this.$root.loading.close();
        },
      });
    }
    return false;
  }
};

Vue.prototype.requestForm = function (url, data, target) {
  $("#submitForm").remove();
  const $form = $('<form id="submitForm"></form>');

  const escape = (s) => String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const append = (name, value) => {
    $form.append('<input type="hidden" name="' + escape(name) + '" value="' + escape(value) + '" />');
  };

  const walk = (name, value) => {
    if (value == null || typeof value === "function") return;
    if (value instanceof Date) {
      append(name, moment(value).format("YYYY-MM-DDTHH:mm"));
    } else if (Array.isArray(value)) {
      value.forEach((v, i) => walk(name + "[" + i + "]", v));
    } else if (typeof value === "object") {
      Object.keys(value).forEach((k) => walk(name ? name + "." + k : k, value[k]));
    } else {
      append(name, value);
    }
  };

  if (data != null) {
    Object.keys(data).forEach((k) => walk(k, data[k]));
  }

  $("body").append($form);
  if (target != null) {
    $("#submitForm").attr("target", target);
  }
  $("#submitForm").attr("method", "post").attr("action", url).submit();
};
